var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 21H3H21Z",
    fill: "#0059B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21H3",
    stroke: "#0059B3",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.5 12H7.5V21H4.5V12ZM10.5 3H13.5V21H10.5V3ZM16.5 7.5H19.5V21H16.5V7.5Z",
    fill: "#0059B3",
    stroke: "#0059B3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 21H3H21Z",
    fill: "#0059B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 21H3",
    stroke: "#0059B3",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.5 12H7.5V21H4.5V12ZM10.5 3H13.5V21H10.5V3ZM16.5 7.5H19.5V21H16.5V7.5Z",
    fill: "#0059B3",
    stroke: "#0059B3",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.2714908f80c35e73c97d0f2dd7a1e2f4.svg";
export { ForwardRef as ReactComponent };